export const Endpoint = () => `/api/v3/celery/addintervaltask`;
export const Csrf = () => `/api/v3/celery/token/`;
export declare const QueryKey: never;
export type Payload = {
    name: string;
    task: string;
    taskType: string;
    every: number;
    period: string;
};
export type Response = void;
